import React, { createContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const tokenUser = authService.getCurrentUser();
    const cachedUser = authService.getCachedCurrentUser();
    const matchingCachedUser = cachedUser && String(cachedUser.id) === String(tokenUser?.id)
      ? cachedUser
      : null;

    setCurrentUser(tokenUser ? { ...(matchingCachedUser || {}), ...tokenUser } : null);
    setLoading(false);

    if (tokenUser) {
      authService.fetchCurrentUser()
        .then(response => {
          if (active) setCurrentUser(response.data.user || response.data);
        })
        .catch(error => {
          console.error('Error refreshing user:', error);
        });
    }

    return () => {
      active = false;
    };
  }, []);

  const login = async (email, password) => {
    try {
      const data = await authService.login(email, password);
      setCurrentUser(data.user || authService.getCurrentUser());
      authService.fetchCurrentUser()
        .then(userResponse => setCurrentUser(userResponse.data.user || userResponse.data))
        .catch(() => {});
      
      return data;
    } catch (error) {
      throw error;
    }
  };

  const register = async (userData) => {
    try {
      const { data } = await authService.register(userData);
      
      // After registration, fetch full user details
      try {
        const userResponse = await authService.fetchCurrentUser();
        setCurrentUser(userResponse.data.user || userResponse.data);
      } catch (error) {
        // Fallback to registration response user data
        setCurrentUser(data.user);
      }
      
      return data;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    register,
    logout,
    isManager: currentUser?.role === 'manager',
    isEmployee: currentUser?.role === 'employee'
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
